(() => {
  const getSectionRoot = (sectionId) =>
    document.querySelector(`#MainProduct-${sectionId}`) ||
    document.querySelector(`product-info[data-section="${sectionId}"]`);

  const syncBuyNowState = (sectionId, variant) => {
    const sectionRoot = getSectionRoot(sectionId);
    if (!sectionRoot) return;

    const submitButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
    const buyNowButtons = document.querySelectorAll(
      `[data-sa-buy-now][data-section-id="${sectionId}"]`,
    );
    const stockStatus = sectionRoot.querySelector('[data-sa-stock-status]');

    if (submitButton && buyNowButtons.length) {
      buyNowButtons.forEach((buyNowButton) => {
        buyNowButton.disabled = submitButton.disabled;
      });
    }

    if (stockStatus && variant) {
      stockStatus.classList.toggle('hidden', !variant.available);
    }
  };

  const getQuantityForCheckout = (form, sectionId) => {
    const quantityInput =
      (sectionId ? document.getElementById(`Quantity-${sectionId}`) : null) ||
      (form.id ? document.querySelector(`input[name="quantity"][form="${form.id}"]`) : null) ||
      form.closest('product-info')?.querySelector('.sa-product-quantity input[name="quantity"]') ||
      form.querySelector('input[name="quantity"]');

    const parsed = parseInt(quantityInput?.value, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
  };

  const initBuyNowButtons = (root = document) => {
    root.querySelectorAll('[data-sa-buy-now]').forEach((button) => {
      if (button.dataset.saBuyNowBound === 'true') return;
      button.dataset.saBuyNowBound = 'true';

      button.addEventListener('click', async (event) => {
        event.preventDefault();
        if (button.disabled) return;

        const formId = button.dataset.productFormId;
        const sectionId = button.dataset.sectionId || button.closest('product-form')?.dataset.sectionId;
        const form = formId ? document.getElementById(formId) : button.closest('product-form')?.querySelector('form');
        if (!form) return;

        const variantId = form.querySelector('.product-variant-id')?.value || form.querySelector('input[name="id"]')?.value;
        if (!variantId) return;

        const quantity = getQuantityForCheckout(form, sectionId);
        const cartClearUrl = '/cart/clear.js';
        const cartAddUrl = window.routes?.cart_add_url || '/cart/add.js';

        button.disabled = true;

        try {
          const clearResponse = await fetch(cartClearUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
          });

          if (!clearResponse.ok) {
            throw new Error('Unable to prepare checkout');
          }

          const addBody = new FormData();
          addBody.append('id', variantId);
          addBody.append('quantity', String(quantity));

          const addResponse = await fetch(cartAddUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: addBody,
          });

          const result = await addResponse.json();

          if (!addResponse.ok || result.status) {
            throw new Error(result.description || result.message || 'Unable to add item to cart');
          }

          window.location.href = `${window.shopUrl || window.location.origin}/checkout`;
        } catch (error) {
          const submitButton = sectionId ? document.getElementById(`ProductSubmitButton-${sectionId}`) : null;
          button.disabled = submitButton?.disabled ?? false;

          const productForm = button.closest('product-form');
          const errorWrapper = productForm?.querySelector('.product-form__error-message-wrapper');
          const errorMessage = productForm?.querySelector('.product-form__error-message');

          if (errorWrapper && errorMessage) {
            errorMessage.textContent = error.message;
            errorWrapper.hidden = false;
          }
        }
      });
    });
  };

  initBuyNowButtons();

  if (typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { sectionId, variant } }) => {
      syncBuyNowState(sectionId, variant);
    });
  }

  document.addEventListener('shopify:section:load', (event) => {
    initBuyNowButtons(event.target);
  });
})();
